

module.exports = __webpack_require__.stylable.create(
    "o34",
    {"classes":{"root":"s329"},"vars":{"header-secondary-logo-width-mob":"--o4-header-secondary-logo-width-mob","header-secondary-logo-width-tablet":"--o4-header-secondary-logo-width-tablet"},"stVars":{},"keyframes":{}},
    "",
    2,
    47,
    null
);
